import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { parseToProjectDetails, parseToProjectDetailsDto, ProjectDetails, ProjectDetailsDto } from "../types/project-details.type";
import { buildProjectPayloadChunkParam, PROJECT_PAYLOAD_CHUNKS } from "@features/project/types/project-payload-chunks.types";
import { HTTP_HEADER_NAMES } from "@shared/common/http-headers.common";

const BASE_URL: string = "api/projects";


@Injectable({
  providedIn: "root"
})
export class ProjectDetailsDataService {
  private readonly _httpClient: HttpClient = inject(HttpClient);

  public getProjectDetails (projectNumber: string): Observable<ProjectDetails> {
    const params: HttpParams = buildProjectPayloadChunkParam(PROJECT_PAYLOAD_CHUNKS.baseData);

    return this._httpClient.get<ProjectDetailsDto>(`${ BASE_URL }/${ projectNumber }`, { params })
      .pipe(
        map(parseToProjectDetails)
      );
  }

  /**
   * Update project details
   */
  public updateProjectDetails (projectNumber: string, projectDetails: ProjectDetails): Observable<HttpResponse<never>> {
    const params: HttpParams = buildProjectPayloadChunkParam(PROJECT_PAYLOAD_CHUNKS.baseData);
    const parsedProjectDetails: ProjectDetailsDto = parseToProjectDetailsDto(projectDetails);

    return this._httpClient.put<never>(`${ BASE_URL }/${ projectNumber }`, parsedProjectDetails, { params, observe: "response" });
  }

  /**
   * Create Project
   * @returns Observable of the created projects number
   */
  public createProject (projectDetails: ProjectDetails): Observable<string> {
    const parsedProject: ProjectDetailsDto = parseToProjectDetailsDto(projectDetails);

    return this._httpClient.post<never>(BASE_URL, parsedProject, { observe: "response" })
      .pipe(
        map((response: HttpResponse<never>) => response.headers.get(HTTP_HEADER_NAMES.location)?.split("/")
          .pop() ?? "")
      );
  }
}
